import React from "react";
import { Box, Avatar, useTheme, IconButton, Modal,Menu,MenuItem } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import BaseCard from "../../../components/Cards/Card";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BASE_URL } from "../../../components/BaseUrl";
import { getProfileDraft, setProfileDraft } from "./ProfileDraft";
import profiledone from "../../../assets/profiledone.svg";
import {useState, useRef} from "react";
import DocumentUpload from "../../../components/DocumentUpload";
import ImageCropper from "../../../components/ImageCropper";
import CloseIcon from "@mui/icons-material/Close";
import imageicon from "../../../assets/imageicon.png";
import document1 from '../../../assets/document1.svg';
import { apiPost } from "../../../utils/apiService";
import Webcam from "react-webcam";
const CompanyDetails = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
formik.validateForm();
}, [i18n.language]);

  const fileInputRef = React.useRef(null);
  const [logoUrl, setLogoUrl] = React.useState("");
  const [uploading, setUploading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [uploadingCompanyDoc, setUploadingCompanyDoc] = React.useState(false);
  const [companyDocFileName, setCompanyDocFileName] = React.useState("");
  const [bizDocAnchorEl, setBizDocAnchorEl] = useState(null);
const openBizDocMenu = Boolean(bizDocAnchorEl);


const openBizDocOptions = (e) => setBizDocAnchorEl(e.currentTarget);
const closeBizDocOptions = () => setBizDocAnchorEl(null);


const [cameraTarget, setCameraTarget] = useState(null);
const [showCamera, setShowCamera] = useState(false);
const webcamRef = useRef(null);
const [capturedImage, setCapturedImage] = useState(null);
const [takingPhoto, setTakingPhoto] = useState(false);


const openCamera = (target) => {
setCameraTarget(target);
setCapturedImage(null);
setShowCamera(true);
};
const takeBusinessIdPhoto = () => {
closeBizDocOptions();
openCamera("businessId");
};
const pickBusinessIdFromGallery = () => {
closeBizDocOptions();
document.getElementById("business-id-input")?.click();
};
  // Image cropper states
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const draft = getProfileDraft();
  const adminTypeFromState = location?.state?.adminType || draft?.administrator_type || "";

  const handlePickFile = () => fileInputRef.current?.click();

  const capturePhoto = async () => {
if (!webcamRef.current) return;


const imageSrc = webcamRef.current.getScreenshot();
if (!imageSrc) {
toast.error("Failed to capture image");
return;
}


setCapturedImage(imageSrc);
setTakingPhoto(true);


try {
// convert base64 → file
const res = await fetch(imageSrc);
const blob = await res.blob();
const file = new File([blob], "business-id-camera.jpg", {
type: "image/jpeg",
});


const formData = new FormData();
formData.append("image", file);


const uploadRes = await fetch(`${BASE_URL}/upload/image`, {
method: "POST",
body: formData,
});


const result = await uploadRes.json();
if (!uploadRes.ok || !result?.data?.url) {
throw new Error("Upload failed");
}


const imageUrl = result.data.url;


// ✅ Business ID target
if (cameraTarget === "businessId") {
formik.setFieldValue("company_document_url", imageUrl);
setCompanyDocFileName("business-id-camera.jpg");
setProfileDraft({
...getProfileDraft(),
company_document_url: imageUrl,
});
}


// toast.success("Photo captured and uploaded");
setShowCamera(false);
} catch (err) {
console.error(err);
toast.error("Failed to upload photo");
} finally {
setTakingPhoto(false);
}
};

  const uploadImageToServer = async (file) => {
    const form = new FormData();
    form.append("image", file);
    const res = await fetch(`${BASE_URL}/upload/image`, { method: "POST", body: form });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    return data?.data?.url || data?.url || data?.path || "";
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    // Create image URL for cropping
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage(imageUrl);
    setCropModalOpen(true);
    
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  
  
  const handleCropComplete = async (croppedImageFile) => {
    if (!croppedImageFile) {
      toast.error(t("selectCropArea"));
      return;
    }
    
    try {
      setUploading(true);
      
      // Use the exact same file that was shown in the preview
      const url = await uploadImageToServer(croppedImageFile);
      setLogoUrl(url);
      toast.success(t("businessLogoUploaded"));
      setCropModalOpen(false);
      setSelectedImage(null);
    } catch (err) {
      console.error('Upload error:', err);
      toast.error(t("failedUploadBusinessLogo"));
    } finally {
      setUploading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      legal_name: draft.legal_name || "",
      trade_name: draft.trade_name || "",
      business_sector: draft.business_sector || "",
      company_registration_number: draft.company_registration_number || "",
      business_email: draft.business_email || "",
      business_phone_number: draft.business_phone_number || "",
      // business_type: draft.business_type || "",
      company_document_url: draft.company_document_url || "",
      business_activity: draft.business_activity || "",
      primary_color: draft.primary_color || "#006EC2",
      secondary_color: draft.secondary_color || "#2C384C",
      business_address: draft.business_address || "",
    },
  validate: (v) => {
const e = {};
if (!v.legal_name) e.legal_name = "registerValidation.required";
if (!v.business_email) e.business_email = "registerValidation.required";
if (!v.business_sector) e.business_sector = "registerValidation.required";
if (!v.business_phone_number) e.business_phone_number = "registerValidation.required";
if (!v.business_activity) e.business_activity = "registerValidation.required";
return e;
},
    onSubmit: async (values) => {
      try {
        setSaving(true);
        setProfileDraft({
          ...values,
          logo: logoUrl || draft.logo || "",
          administrator_type: adminTypeFromState,
        });
        setTimeout(() => {
          navigate("/location");
          setSaving(false);
        }, 1000);
      } catch {
        toast.error(t("failedSaveCompanyDetails"));
        setSaving(false);
      }
    },
  });

  // React.useEffect(() => {
  //   if (draft.logo) setLogoUrl(draft.logo);
  // }, []);

  React.useEffect(() => {
  if (draft.logo) setLogoUrl(draft.logo);
  if (draft.company_document_url) {
    formik.setFieldValue("company_document_url", draft.company_document_url);
    const fileName = draft.company_document_url.split("/").pop();
    setCompanyDocFileName(fileName || "Uploaded Document");
  }
}, []);

  // Upload company legal document (PDF/DOC/DOCX)
  const uploadCompanyDocToServer = async (file) => {
    const form = new FormData();
    form.append("pdf", file);
    const res = await fetch(`${BASE_URL}/upload/pdf`, { method: "POST", body: form });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    return data?.data?.url || data?.url || data?.path || "";
  };

const handleCompanyDocChange = async (file) => {
  if (file === null) {
    setCompanyDocFileName("");
    formik.setFieldValue("company_document_url", "");
    return;
  }
  if (!file) return;

  try {
    setUploadingCompanyDoc(true);
    setCompanyDocFileName(file.name);

    let url = "";
    const form = new FormData();

    if (file.type.startsWith("image/")) {
      form.append("image", file);
      const res = await fetch(`${BASE_URL}/upload/image`, { method: "POST", body: form });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Image upload failed");
      url = data?.data?.url || data?.url || data?.path || "";
    } else if (
      file.type === "application/pdf" ||
      file.type === "application/msword" ||
      file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      form.append("pdf", file);
      const res = await fetch(`${BASE_URL}/upload/pdf`, { method: "POST", body: form });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Document upload failed");
      url = data?.data?.url || data?.url || data?.path || "";
    } else {
      toast.error(t("unsupportedFileType"));
      return;
    }

    // ✅ Update both Formik and your saved draft immediately
    formik.setFieldValue("company_document_url", url);
    setProfileDraft({ ...getProfileDraft(), company_document_url: url });

    toast.success(t("businessIdUploaded"));
  } catch (err) {
    console.error("Upload error:", err);
    toast.error(err.message || t("failedUploadDocument"));
    formik.setFieldValue("company_document_url", "");
    setCompanyDocFileName("");
  } finally {
    setUploadingCompanyDoc(false);
  }
};

const fileExt = companyDocFileName?.split(".").pop()?.toLowerCase();

const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExt);
const isPdf = fileExt === "pdf";
const [isContinueClicked, setIsContinueClicked] = useState(false);

  return (
    <>
      <Box sx={{ py: isMobile ? 5 : 8, px: 2, mt: isMobile ? 2 : 0 }}>
      <Box sx={{ display: "flex", justifyContent: "center", minHeight: "100vh", alignItems: "center" }}>
        <BaseCard maxWidth={isMobile ? "100%" : isTablet ? "67%" : isLaptop ? "37%" : "46%"}>
          {/* Stepper */}
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
              <Box sx={{ width: isMobile ? 35 : 95, height: 2, backgroundColor: "#091E4224" }} />
              <Box sx={{ width: 25, height: 25, borderRadius: "50%", backgroundColor: theme.palette.primary.main, color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>2</Box>
              <Box sx={{ width: isMobile ?35 : 95, height: 2, backgroundColor: "#091E4224" }} />
              <Box sx={{ width: 25, height: 25, borderRadius: "50%", backgroundColor: "#fff", color: "#BCBFC2", border: "2px solid #091E4224", display: "flex", justifyContent: "center", alignItems: "center" }}>3</Box>
                <Box sx={{ width: isMobile ?35 : 95, height: 2, backgroundColor: "#091E4224" }} />
              <Box sx={{ width: 25, height: 25, borderRadius: "50%", backgroundColor: "#fff", color: "#BCBFC2", border: "2px solid #091E4224", display: "flex", justifyContent: "center", alignItems: "center" }}>4</Box>
            </Box>
          </Box>

          <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main, textAlign: "left", fontSize: "26px" }}>
        {t("companyDetailsTitle")}
          </CustomText>
          <CustomText sx={{ ...textStyles.body5, color: theme.palette.text.primary, pt: 0.7, textAlign: "left" }}>
              {t("companyDetailsSubtitle")}
          </CustomText>

          {/* Form */}
          <form onSubmit={formik.handleSubmit}>
            {/* Logo Upload */}
            <Box sx={{ mb: 2, mt: 2 }}>
              <label style={{ color: "#626F86", fontSize: "15px", letterSpacing: "0.3px", display: "inline-block", marginBottom: 7 }}>{t("companyLogo")}</label>
           


              <Box sx={{ mt: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
  <Box
    sx={{
      position: "relative",
      width: 260,        // RECTANGLE WIDTH
      height: 140,       // RECTANGLE HEIGHT
      border: "2px dashed #091E4224",
      borderRadius: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: uploading ? "not-allowed" : "pointer",
      overflow: "hidden",
      backgroundColor: "#ffffff",
      transition: "0.2s",
      "&:hover": { borderColor: theme.palette.primary.main }
    }}
    onClick={() => !uploading && handlePickFile()}
  >
    {logoUrl ? (
      <img
        crossOrigin="anonymous"
        src={logoUrl}
        alt="Company Logo"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          backgroundColor: "white",
        }}
      />
    ) : (
      <Box sx={{ textAlign: "center", color: "#888" }}>
        <CustomButton 
          label={t("uploadLogoButton")}
          size="small"
          sx={{
            px: 3,
            py: 1,
            borderRadius: "6px"
          }}
        />
        <div style={{ fontSize: 12, marginTop: 8 }}>{t("clickToUploadLogo")}</div>
      </Box>
    )}

    {/* Add Icon — visible only when logo is uploaded */}
{logoUrl && (
  <IconButton
    size="small"
    sx={{
      position: "absolute",
      top: 8,
      right: 8,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      boxShadow: 1,
      "&:hover": { backgroundColor: "#f0f0f0" }
    }}
    onClick={(e) => {
      e.stopPropagation();
      setLogoUrl("");              // remove logo
      setSelectedImage(null);      // reset crop state
      formik.setFieldValue("logo", ""); // remove from formik if saved
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
)}

    {uploading && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.75)",
        }}
      >
        <CircularProgress size={28} />
      </Box>
    )}
  </Box>

  <input
    ref={fileInputRef}
    type="file"
    accept="image/*"
    hidden
    onChange={handleFileChange}
  />
</Box>


            </Box>

            {/* Two in one row */}
       <Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", gap: 1, mb: 2 }}>
  <Box sx={{ flex: 1 }}>
    <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
        {adminTypeFromState === 'individual' ? t("businessName") : t("companyLegalName")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      className="project_input"
      name="legal_name"
      value={formik.values.legal_name}
      onChange={formik.handleChange}
      style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 ,
             border:
        formik.errors.legal_name && formik.touched.legal_name
          ? "1px solid red"
          : "2px solid #091E4224",
      }}
    />
    {formik.errors.legal_name && (
      <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.legal_name)}</Box>
    )}
  </Box>

  {adminTypeFromState !== 'individual' && (
    <Box sx={{ flex: 1 }}>
      <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
        {t("companyBusinessName")}</label>
      <input
        className="project_input"
        name="trade_name"
        value={formik.values.trade_name}
        onChange={formik.handleChange}
        style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14,
               
         }}
      />
    </Box>
 )} 
</Box>

            {/* Business Activity */}
            <Box sx={{ mb: 0 }}>
              <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>{t("businessActivity")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                className="project_input"
                name="business_activity"
                value={formik.values.business_activity}
                onChange={formik.handleChange}
                style={{ minHeight: 80, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14, padding: 8,
                            border:
        formik.errors.business_activity&& formik.touched.business_activity
          ? "1px solid red"
          : "2px solid #091E4224",
                 }}
              />
               {formik.errors.business_activity && (
      <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.business_activity)}</Box>
    )}
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", gap: 1, mb: 2 }}>
              {/* <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", display: "inline-block", marginBottom: 7 }}>{t("businessSector")} <span style={{ color: "red" }}>*</span></label>
                <input className="project_input" name="business_sector" value={formik.values.business_sector} onChange={formik.handleChange} style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14,
                        border:
        formik.errors.business_sector && formik.touched.business_sector
          ? "1px solid red"
          : "2px solid #091E4224", // ✅ red border when invalid
    
                 }} />
                   {formik.touched.business_sector && formik.errors.business_sector && (
    <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>
      {formik.errors.business_sector}
    </Box>
  )}
              </Box> */}
              {adminTypeFromState !== 'individual' && (
                <Box sx={{ flex: 1 }}>
                  <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>{t("companyRegNumber")}</label>
                  <input className="project_input" name="company_registration_number" value={formik.values.company_registration_number} onChange={formik.handleChange} style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 }} />
                </Box>
              )}
            </Box>

<Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", gap: 1, mb: 1 }}>
  <Box sx={{ flex: 1 }}>
    <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
{t("businessEmail")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      className="project_input"
      name="business_email"
      value={formik.values.business_email}
      onChange={formik.handleChange}
      style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 ,
    border: formik.errors.business_email&& formik.touched.business_email ? "1px solid red" : "2px solid #091E4224", // Conditionally apply red border

      }}
    />
    {formik.errors.business_email && (
      <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.business_email)}</Box>
    )}
  </Box>

  <Box sx={{ flex: 1,mt:0.5, }}>
    <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
    {t("businessPhone")}  <span style={{ color: "red" }}>*</span>
    </label>
    <Box
      sx={{
   border: formik.errors.business_phone_number && formik.touched.business_phone_number ? "1px solid red" : "2px solid #091E4224", // Conditionally apply red border

        // border: "2px solid  #091E4224",
        borderRadius: "6px",
        "& .form-control": {
          border: "none !important",
          outline: "none !important",
          boxShadow: "none !important",
          width: "100%",
          height: "36px",
          fontSize: "14px",

          paddingLeft: "48px",
          borderRadius: "6px",
          fontFamily: "Poppins, sans-serif !important",
        },
        "& .flag-dropdown": {
          border: "none !important",
          borderRight: "1px solid #ccc !important",
          backgroundColor: "#f9f9f9",
          borderTopLeftRadius: "6px",
          borderBottomLeftRadius: "6px",
        },
      }}
    >
      <PhoneInput
        country={"us"}
        value={formik.values.business_phone_number}
        onChange={(value) => formik.setFieldValue("business_phone_number", value)}
        inputProps={{ name: "business_phone_number", required: true }}
        countryCodeEditable={false} 
      />
    </Box>
    {formik.errors.business_phone_number && (
      <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.business_phone_number)}</Box>
    )}
  </Box>
</Box>
<Box sx={{ flex: 1,mb:2, }}>
  <label
    style={{
      color: "#626F86",
      fontSize: 14,
      letterSpacing: "0.3px",
      display: "inline-block",
      marginBottom: 7,
    }}
  >
    {t("businessSector")} <span style={{ color: "red" }}>*</span>
  </label>

  <select
    name="business_sector"
    value={formik.values.business_sector}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    className="project_input"
    style={{
      height: 38,
      borderRadius: 6,
      width: "100%",
      marginTop: 5,
      fontSize: 14,
      border:
        formik.errors.business_sector && formik.touched.business_sector
          ? "1px solid red"
          : "2px solid #091E4224",
      paddingRight: "28px",
      appearance: "none",
      backgroundImage:
        "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath fill='black' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      backgroundSize: "12px 8px",
    }}
  >
    <option value="" disabled>
      {t("registerValidation.selectBusinessSector")}
    </option>

    <option value="Field Services">{t("registerValidation.fieldServices")}</option>
    <option value="Construction">{t("registerValidation.construction")}</option>
    <option value="Delivery & Logistics">{t("registerValidation.deliveryLogistics")}</option>
    <option value="Retail">{t("registerValidation.retail")}</option>
    <option value="Healthcare & Home Care">{t("registerValidation.healthcareHomeCare")}</option>
    <option value="Security Services">{t("registerValidation.securityServices")}</option>
    <option value="IT Services & Support">{t("registerValidation.itServicesSupport")}</option>
    <option value="Corporate / Office Work">{t("registerValidation.corporateOfficeWork")}</option>
    <option value="Hospitality">{t("registerValidation.hospitality")}</option>
    <option value="Education & Training">{t("registerValidation.educationTraining")}</option>
    <option value="Government & Public Services">{t("registerValidation.governmentPublicServices")}</option>
    <option value="Other">{t("registerValidation.other")}</option>
  </select>

  {formik.touched.business_sector && formik.errors.business_sector && (
    <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>
      {t(formik.errors.business_sector)}
    </Box>
  )}
</Box>

            {/* New fields: Primary Color, Secondary Color, Business Address */}
            <Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", gap: 1, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("primaryColor")}
                </label>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                  {/* Color Box */}
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      border: "2px solid #ddd",
                      backgroundColor: formik.values.primary_color,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.2s ease",
                      position: "relative",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const colorInput = e.currentTarget.querySelector('input[type="color"]');
                      if (colorInput) {
                        colorInput.click();
                      }
                    }}
                  >
                    <input
                      type="color"
                      name="primary_color"
                      value={formik.values.primary_color}
                      onChange={formik.handleChange}
                      style={{ 
                        position: "absolute", 
                        opacity: 0, 
                        width: "100%", 
                        height: "100%", 
                        cursor: "pointer",
                        zIndex: 1
                      }}
                    />
                  </Box>
                  
                  {/* Color Input Field */}
                  <input
                    type="text"
                    className="project_input"
                    name="primary_color"
                    value={formik.values.primary_color}
                    onChange={formik.handleChange}
                    placeholder="#000000"
                    style={{ 
                      height: 50, 
                      borderRadius: 6, 
                      flex: 1, 
                      fontSize: 14,
                      fontFamily: "monospace"
                    }}
                  />
                </Box>
              </Box>
              
              <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("secondaryColor")}
                </label>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                  {/* Color Box */}
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      border: "2px solid #ddd",
                      backgroundColor: formik.values.secondary_color,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.2s ease",
                      position: "relative",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const colorInput = e.currentTarget.querySelector('input[type="color"]');
                      if (colorInput) {
                        colorInput.click();
                      }
                    }}
                  >
                    <input
                      type="color"
                      name="secondary_color"
                      value={formik.values.secondary_color}
                      onChange={formik.handleChange}
                      style={{ 
                        position: "absolute", 
                        opacity: 0, 
                        width: "100%", 
                        height: "100%", 
                        cursor: "pointer",
                        zIndex: 1
                      }}
                    />
                  </Box>
                  
                  {/* Color Input Field */}
                  <input
                    type="text"
                    className="project_input"
                    name="secondary_color"
                    value={formik.values.secondary_color}
                    onChange={formik.handleChange}
                    placeholder="#000000"
                    style={{ 
                      height: 50, 
                      borderRadius: 6, 
                      flex: 1, 
                      fontSize: 14,
                      fontFamily: "monospace"
                    }}
                  />
                </Box>
              </Box>
            </Box>

            {/* Business Address (only for legal entity) */}
            {adminTypeFromState === 'legal_entity' && (
              <Box sx={{ mb: 2 }}>
                <label style={{ color: "#626F86", fontSize: 14, letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("businessAddress")}
                </label>
                <textarea
                  className="project_input"
                  name="business_address"
                  value={formik.values.business_address}
                  onChange={formik.handleChange}
                  style={{ minHeight: 80, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14, padding: 8 }}
                  placeholder={t("businessAddress")}
                />
              </Box>
            )}

            {/* Company Document (only for legal entity) */}
            {/* {adminTypeFromState === 'legal_entity' && ( */}
             <Box
onClick={(e) => {
e.stopPropagation();
e.preventDefault();
openBizDocOptions(e);
}}
>
<DocumentUpload
label={t("businessId")}
onFileSelect={handleCompanyDocChange}
fileName={companyDocFileName}
isUploading={uploadingCompanyDoc}
accept="image/*,.pdf"
disabled={uploadingCompanyDoc}
fileIcon={isImage ? imageicon : isPdf ? document1 : null}
/>
</Box>
              <input
id="business-id-input"
type="file"
accept="image/*,.pdf"
hidden
onChange={(e) => {
const file = e.target.files?.[0];
if (file) handleCompanyDocChange(file);
e.target.value = "";
}}
/>
<Menu
  anchorEl={bizDocAnchorEl}
  open={openBizDocMenu}
  onClose={closeBizDocOptions}
>
  <MenuItem onClick={takeBusinessIdPhoto} 
  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
    {t("takePhoto")}
  </MenuItem>

  <MenuItem onClick={pickBusinessIdFromGallery}
  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
    {t("chooseFromGallery")}
  </MenuItem>
</Menu>
            {/* )} */}

            {/*  */}
                        <Box sx={{ display: "flex",alignItems:"center", justifyContent: "flex-end",mt:2,gap: 2 }}>
  <CustomButton
    label={t("back")}
    onClick={() => navigate(-1)}
    size="medium"
    disabled={saving} 
    sx={{
      fontSize:"16px",
      px: 4,
     backgroundColor: saving ? "#d9d9d9" : "#f0f0f0",
    color: "black",
  
    }}
  />

 <CustomButton
              label={
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {saving && <CircularProgress size={18} sx={{ color: "#fff" }} />}
                  {t("next")}
                </Box>
              }
         size="medium"
              type="submit"
              disabled={saving}
              sx={{py:1,px:6,}}
        // onClick={() => setIsContinueClicked(true)}  
            />
</Box>
          </form>
        </BaseCard>
      </Box>
      
      {/* Image Cropper Modal */}
      {cropModalOpen && (
        <ImageCropper
          onCropComplete={handleCropComplete}
          selectedImage={selectedImage}
          onClose={() => {
            setCropModalOpen(false);
            setSelectedImage(null);
          }}
        />
      )}
    </Box>
    {showCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1300,
      p: 2,
    }}
  >
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "24px",
        width: "100%",
        maxWidth: 600,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%" }}>
        {!capturedImage ? (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{
              facingMode: "environment", // 👈 rear camera for IDs
            }}
            style={{
              width: "100%",
              borderRadius: "12px",
            }}
          />
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{
              width: "100%",
              borderRadius: "12px",
            }}
          />
        )}
      </Box>

      <Box sx={{ display: "flex", gap: 2, mt: 3, width: "100%" }}>
        {!capturedImage ? (
          <CustomButton
            label={takingPhoto ? t("uploading") : t("capture")}
            onClick={capturePhoto}
            disabled={takingPhoto}
            sx={{ flex: 1 }}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedImage(null)}
            sx={{ flex: 1 }}
          />
        )}

        <CustomButton
          label={t("close")}
          onClick={() => setShowCamera(false)}
          sx={{
            flex: 1,
            backgroundColor: "#E0E0E0",
            color: "#333",
          }}
        />
      </Box>
    </Box>
  </Box>
)}
    </>
  );
};

export default CompanyDetails;

